export default __webpack_public_path__ + "static/media/icomoon.7cc7f47b.woff";